<template>
  <div @mousemove="moveIn" @mouseout="remove">
    <div class="imgDiv" v-if="imgUrl">
      <el-image
        :src="imgUrl"
        :class="[imgState ? 'imgWidth' : 'imgHeight', 'img']"
        :preview-src-list="[imgUrl]"
      >
        <div slot="placeholder" class="image-slot">
          加载中<span class="dot">...</span>
        </div>
      </el-image>
      <span
        v-show="!isHidden && imgUrl"
        @click="handleDownload(imgUrl)"
        class="downloadImg"
      >
        <i class="el-icon-download"></i>
      </span>
    </div>
    <div v-else>--</div>
  </div>
</template>

<script>
import { interfacePrefix } from '@/config'

export default {
  name: 'EnlargeImg',
  props: {
    imgSrc: {
      default: '',
    },
  },
  watch: {
    // imgSrc获取有可能是异步，需要监听数据改变
    imgSrc: {
      handler(v) {
        if (!v) return
        this.getImgInfo()
        this.imgName = v.name || this.getFileName(v) || ''
      },
      immediate: true,
    },
  },
  data() {
    return {
      isHidden: true,
      imgWidth: 0,
      imgHeight: 0,
      imgName: null,
    }
  },
  computed: {
    imgState() {
      return this.imgWidth - this.imgHeight > 0
    },
    imgUrl() {
      if (!this.imgSrc) return ''
      return this.imgSrc.url || this.imgSrc
    },
  },
  methods: {
    getImgInfo() {
      const img = new Image()
      img.src = this.imgUrl
      img.onload = () => {
        this.imgWidth = img.width
        this.imgHeight = img.height
      }
    },
    moveIn() {
      this.isHidden = false
    },
    remove() {
      this.isHidden = true
    },
    /**
     * 下载图片
     * @param {String} fileUrl 图片地址
     */
    handleDownload(fileUrl) {
      if (fileUrl.indexOf('http') === 0) {
        /**
         * 下载网络图片
         */
        fetch(fileUrl).then((res) => res.blob()).then((blob) => {
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = this.imgName || 'image'
          document.body.appendChild(link)
          link.click()
        })
      } else {
        /**
         * 下载后端图片，兼容历史逻辑
         */
        const url = fileUrl.slice(fileUrl.indexOf('?') + 1)
        location.href = `${interfacePrefix}/fs/download?${url}`
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.imgDiv {
  position: relative;
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 4px;
}
.img {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.img {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
  .image-slot {
    position: absolute;
    top: 50%;
    left: 50%;
    text-align: center;
    transform: translate(-50%, -50%);
    white-space: nowrap;
  }
}
.imgHeight {
  ::v-deep .el-image__inner {
    width: 100%;
    height: auto;
  }
}
.imgWidth {
  ::v-deep .el-image__inner {
    width: auto;
    height: 80px;
  }
}
.downloadImg {
  position: absolute;
  right: 0;
  bottom: 0;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  z-index: 10;
  font-weight: 700;
}
::v-deep .el-icon-download {
  font-weight: 700;
}
</style>
